"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var account_1 = require("./account");

var class_validator_1 = require("class-validator");

var pagination_1 = require("./pagination");

var userForm_1 = require("./userForm");

var country_1 = require("./country");

var UserTypes;

(function (UserTypes) {
  UserTypes["Visitor"] = "Visitor";
  UserTypes["Contact"] = "Contact";
  UserTypes["Registered"] = "Registered";
})(UserTypes = exports.UserTypes || (exports.UserTypes = {}));

var AgeRange;

(function (AgeRange) {
  AgeRange["From18To30"] = "18 - 30";
  AgeRange["From30To50"] = "30 - 50";
  AgeRange["From50To65"] = "50 - 65";
  AgeRange["From65"] = "Plus de 65 ans";
})(AgeRange = exports.AgeRange || (exports.AgeRange = {}));

var MatrimonialRegimeTypes;

(function (MatrimonialRegimeTypes) {
  MatrimonialRegimeTypes["Single"] = "C\xE9libataire";
  MatrimonialRegimeTypes["InCohabitation"] = "En concubinage";
  MatrimonialRegimeTypes["CivilPartnership"] = "Pacs\xE9(e)";
  MatrimonialRegimeTypes["MariedWithoutContract"] = "Mari\xE9(e) sans contrat";
  MatrimonialRegimeTypes["MariedWithContract"] = "Mari\xE9(e) avec contrat";
  MatrimonialRegimeTypes["Divorced"] = "Divorc\xE9(e)";
})(MatrimonialRegimeTypes = exports.MatrimonialRegimeTypes || (exports.MatrimonialRegimeTypes = {}));

var IncomeTaxRanges;

(function (IncomeTaxRanges) {
  IncomeTaxRanges["From3000To5000"] = "Entre 3000 et 5000 \u20AC";
  IncomeTaxRanges["From5000To8000"] = "Entre 5000 et 8000 \u20AC";
  IncomeTaxRanges["From8000To13000"] = "Entre 8000 et 13000 \u20AC";
  IncomeTaxRanges["From13000"] = "Plus de 13000 \u20AC";
})(IncomeTaxRanges = exports.IncomeTaxRanges || (exports.IncomeTaxRanges = {}));

var ModalMessage;

(function (ModalMessage) {
  ModalMessage["UnsubscribeOk"] = "UnsubscribeOk";
  ModalMessage["ValidateAccountOk"] = "ValidateAccountOk";
  ModalMessage["AskForPassword"] = "AskForPassword";
  ModalMessage["CheckTokenFailed"] = "CheckTokenFailed";
})(ModalMessage = exports.ModalMessage || (exports.ModalMessage = {}));

var UserDTO = function UserDTO() {
  _classCallCheck(this, UserDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], UserDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "firstName", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "lastName", void 0);

__decorate([class_validator_1.IsEnum(AgeRange), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "ageRange", void 0);

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], UserDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsPhoneNumber('FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "street", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserDTO.prototype, "income", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "isAnnualIncome", void 0);

__decorate([class_validator_1.IsEnum(IncomeTaxRanges), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "lastIncomeTax", void 0);

__decorate([class_validator_1.IsEnum(MatrimonialRegimeTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "matrimonialRegime", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "isJointPurchaser", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserDTO.prototype, "childNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserDTO.prototype, "taxShareNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserDTO.prototype, "lastFiscalIncome", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "isOwner", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserDTO.prototype, "signupOrig", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "contactByPhone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "contactBySms", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "contactByMail", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "messageNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "wishNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "wishAvailableNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "newProgramNotification", void 0);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", Date)], UserDTO.prototype, "createDate", void 0);

__decorate([class_validator_1.IsInstance(userForm_1.UserFormCreationDTO, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Array)], UserDTO.prototype, "forms", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "isMember", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserDTO.prototype, "hasFilledContact", void 0);

exports.UserDTO = UserDTO;

var UserCreationDTO =
/*#__PURE__*/
function (_account_1$AccountCre) {
  _inherits(UserCreationDTO, _account_1$AccountCre);

  function UserCreationDTO() {
    _classCallCheck(this, UserCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserCreationDTO).apply(this, arguments));
  }

  return UserCreationDTO;
}(account_1.AccountCreationDTO);

__decorate([class_validator_1.IsPhoneNumber('FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], UserCreationDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], UserCreationDTO.prototype, "signupOrig", void 0);

exports.UserCreationDTO = UserCreationDTO;

var UserTokenCreationDTO = function UserTokenCreationDTO() {
  _classCallCheck(this, UserTokenCreationDTO);
};

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], UserTokenCreationDTO.prototype, "country", void 0);

exports.UserTokenCreationDTO = UserTokenCreationDTO;

var UserTokenDTO = function UserTokenDTO() {
  _classCallCheck(this, UserTokenDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], UserTokenDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "contactByPhone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "contactBySms", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "contactByMail", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "messageNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "wishNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "wishAvailableNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserTokenDTO.prototype, "newProgramNotification", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], UserTokenDTO.prototype, "token", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], UserTokenDTO.prototype, "country", void 0);

exports.UserTokenDTO = UserTokenDTO;

var UserFormDTO = function UserFormDTO() {
  _classCallCheck(this, UserFormDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], UserFormDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], UserFormDTO.prototype, "firstName", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], UserFormDTO.prototype, "lastName", void 0);

__decorate([class_validator_1.IsEmail(), __metadata("design:type", String)], UserFormDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsPhoneNumber('FR'), __metadata("design:type", String)], UserFormDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "contactByPhone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "contactBySms", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "contactByMail", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "messageNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "wishNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "wishAvailableNotification", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "newProgramNotification", void 0);

__decorate([class_validator_1.IsInstance(userForm_1.UserFormCreationDTO, {
  each: true
}), __metadata("design:type", Array)], UserFormDTO.prototype, "forms", void 0);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", Date)], UserFormDTO.prototype, "createDate", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], UserFormDTO.prototype, "isMember", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], UserFormDTO.prototype, "country", void 0);

exports.UserFormDTO = UserFormDTO;

var UserUpdateDTO =
/*#__PURE__*/
function (_account_1$AccountUpd) {
  _inherits(UserUpdateDTO, _account_1$AccountUpd);

  function UserUpdateDTO() {
    _classCallCheck(this, UserUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserUpdateDTO).apply(this, arguments));
  }

  return UserUpdateDTO;
}(account_1.AccountUpdateDTO);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "firstName", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "lastName", void 0);

__decorate([class_validator_1.IsEnum(AgeRange), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "ageRange", void 0);

__decorate([class_validator_1.IsEmail(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsPhoneNumber('FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "street", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserUpdateDTO.prototype, "income", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "isAnnualIncome", void 0);

__decorate([class_validator_1.IsEnum(IncomeTaxRanges), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "lastIncomeTax", void 0);

__decorate([class_validator_1.IsEnum(MatrimonialRegimeTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "matrimonialRegime", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "isJointPurchaser", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserUpdateDTO.prototype, "childNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserUpdateDTO.prototype, "taxShareNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], UserUpdateDTO.prototype, "lastFiscalIncome", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "isOwner", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserUpdateDTO.prototype, "signupOrig", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "contactByPhone", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "contactBySms", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "contactByMail", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "messageNotification", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "wishNotification", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "wishAvailableNotification", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserUpdateDTO.prototype, "newProgramNotification", void 0);

exports.UserUpdateDTO = UserUpdateDTO;

var UserFilterDTO = function UserFilterDTO() {
  _classCallCheck(this, UserFilterDTO);
};

__decorate([class_validator_1.IsPhoneNumber('FR'), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserFilterDTO.prototype, "onlyContact", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], UserFilterDTO.prototype, "includeMembers", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "from", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], UserFilterDTO.prototype, "to", void 0);

exports.UserFilterDTO = UserFilterDTO;
var UserOrderEnum;

(function (UserOrderEnum) {
  UserOrderEnum["createDate"] = "createDate";
  UserOrderEnum["email"] = "email";
})(UserOrderEnum = exports.UserOrderEnum || (exports.UserOrderEnum = {}));

var UserTokenData = function UserTokenData() {
  _classCallCheck(this, UserTokenData);
};

exports.UserTokenData = UserTokenData;

var UserPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(UserPaginationResponse, _pagination_1$Paginat);

  function UserPaginationResponse() {
    _classCallCheck(this, UserPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserPaginationResponse).apply(this, arguments));
  }

  return UserPaginationResponse;
}(pagination_1.PaginationResponse);

exports.UserPaginationResponse = UserPaginationResponse;

var UserFormPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat2) {
  _inherits(UserFormPaginationResponse, _pagination_1$Paginat2);

  function UserFormPaginationResponse() {
    _classCallCheck(this, UserFormPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserFormPaginationResponse).apply(this, arguments));
  }

  return UserFormPaginationResponse;
}(pagination_1.PaginationResponse);

exports.UserFormPaginationResponse = UserFormPaginationResponse;